import { Redirect, useLocation } from "react-router-dom";

/**
 * Redirige l’ancienne route /waste vers le parcours Paramètres.
 */
const WasteLegacyRedirect = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const wasteId = params.get("wasteId");
  const openCreate = params.get("openCreate");
  const sortingErrors = params.get("sortingErrors");

  if (openCreate === "true") {
    return <Redirect to="/settings/waste/new" />;
  }

  if (wasteId) {
    const tab = sortingErrors === "true" ? "proUnauthorized" : "general";
    return (
      <Redirect
        to={{
          pathname: `/settings/waste/${wasteId}`,
          search: tab !== "general" ? `?tab=${tab}` : "",
        }}
      />
    );
  }

  return (
    <Redirect
      to={{
        pathname: "/settings/waste",
        search: location.search,
      }}
    />
  );
};

export default WasteLegacyRedirect;
